module.exports = __webpack_public_path__ + "static/img/banner-img02.8e7e650.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/banner-img02.png
// module id = Aitj
// module chunks = 44